module.exports = __webpack_public_path__ + "58f9bf2b5803c048e33905b6507d47b9.jpg";